import { EntityInfo } from "@codat/orchard-ui";
import * as React from "react";

import styles from "../../CompaniesTable/CompaniesTable.module.css";

interface CompanyNameModel {
  key: "company";
  value: {
    companyName: string;
    companyId: string;
  };
}

const CompanyNameCell: React.FC<Pick<CompanyNameModel, "value">> = ({
  value,
}) => {
  return (
    <EntityInfo
      title={value.companyName}
      className={styles.entityInfo}
      subtitle={value.companyId}
    />
  );
};

export default CompanyNameCell;
